export const formatCurrency = (num) => {
    return Number(num).toFixed(2).replace('.', ',')
}
